import classNames from 'classnames';
import mapProps from 'recompose/mapProps';
import lensProp from 'ramda/es/lensProp';
import over from 'ramda/es/over';

import styles from './markup.module.scss';;


const classNameLens = lensProp('className');

export const Green = mapProps(over(
  classNameLens,
  className => classNames(styles.green, className),
))('span');

export const Dipper = mapProps(over(
  classNameLens,
  className => classNames(styles.green, className),
))('span');
